import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { PreventTransitionPrompt } from '@michelin/acid-components';
import { useForm } from 'react-hook-form';
import { GenericActionButtonsMassUpdate } from 'components/GenericActionButtons/GenericActionButtonsMassUpdate';
import { CheckboxGroup } from 'components/CommercialServices/CheckboxGroup';
import { CommercialProductsFields_MassST, CommercialProducts_MassST } from '../../CommercialProducts/CommercialProductsFields';

interface Props {
  action: 'edit' | 'view' | 'add',
  fromMassUpdate: boolean,
}

function CommercialProductsPanel(props: Props) {
  const { t } = useTranslation();

  const {
    control, formState, getValues, setValue, reset, handleSubmit, watch,
  } = useForm<CommercialProducts_MassST>({ defaultValues: {} as CommercialProducts_MassST });

  const onRetreadsChange = (data:CommercialProducts_MassST, value: boolean) => {
    if (!data.oliver_retreads && !data.megamile_retreads && data.ultra_low_profile_wide_design_retreads) {
      setValue('ultra_low_profile_wide_design_retreads', value);
    }
  };

  useEffect(() => {
    if (props.action === 'view') reset();
  }, [props.action, reset]);

  return (
    <>
      {(props.fromMassUpdate || false) && (
        <GenericActionButtonsMassUpdate
          isDirty={formState.isDirty}
          getValues={getValues}
          reset={reset}
          handleSubmit={handleSubmit}
          validateAction="mass_st_update.update"
        />
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CheckboxGroup
            getValues={getValues}
            title={t('Commercial Truck Products')}
            control={control}
            readOnly={false}
            cols={6}
            labels={CommercialProductsFields_MassST}
            setValue={setValue}
            watch={watch}
            items={[
              { key: 'x_one_tires' },
              { key: 'mrt_dealer' },
              { key: 'oliver_retreads', onChange: () => onRetreadsChange(getValues(), false) },
              { key: 'megamile_retreads', onChange: () => onRetreadsChange(getValues(), false) },
              { key: 'ultra_low_profile_wide_design_retreads', enabledIf: ['oliver_retreads', 'megamile_retreads'] },
            ]}
          />
        </Grid>
      </Grid>
      <PreventTransitionPrompt
        when={formState.isDirty}
      />
    </>
  );
}

export default CommercialProductsPanel;
